var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClear = function SvgClear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.388235 0 0 0 0 0.458824 0 0 0 0 0.552941 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#515A65",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.63620523 4.42263207L1.47647628 7.8236949c-.21839303.23507347-.5715392.23507347-.7876089 0l-.52507261-.56517661c-.21839303-.23507346-.21839303-.61519225 0-.84776493L2.403485 4 .16379477 1.58924664c-.21839303-.23507346-.21839303-.61519225 0-.84776493L.68886738.1763051c.21839303-.23507347.5715392-.23507347.7876089 0l3.15972895 3.40106283c.21839303.23007189.21839303.61019068 0 .84526414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36379477 4.42263207L6.52352372 7.8236949c.21839303.23507347.5715392.23507347.7876089 0l.52507261-.56517661c.21839303-.23507346.21839303-.61519225 0-.84776493L5.596515 4l2.23969023-2.41075336c.21839303-.23507346.21839303-.61519225 0-.84776493L7.31113262.1763051c-.21839303-.23507347-.5715392-.23507347-.7876089 0L3.36379477 3.57736793c-.21839303.23007189-.21839303.61019068 0 .84526414z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clear.26371e5f.svg";
export { ForwardRef as ReactComponent };